module.exports = __webpack_public_path__ + "static/media/user-icon.05a60778.svg";